import styled, { css } from "styled-components";

const currentPage = css`
  box-shadow: 0 4px 10px 0 rgba(42, 46, 67, 0.2);
  background-color: #2a2e43;
  color: white;
`;

const border = css`
  border-radius: 8px;
  border: solid 1px #2a2e43;
  width: 60px;
`;

const PaginationItemBtn = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2.5px;
  margin-left: 2.5px;
  font-size: 1.15em;
  background-color: transparent;
  transition: 1.2s;

  ${(props) => (props.current ? currentPage : null)};

  ${(props) => (props.border ? border : null)}
`;

export default PaginationItemBtn;
